import { EventCatalogFromKeys, EventType } from "../../types";

export const AdminBillingEventKeys = {
  BILLING_ENTERPRISE_CONTACT: "billing-enterprise-contact",
  BILLING_INTERVAL_CHANGE: "billing-interval-change",
  BILLING_PLAN_SELECT: "billing-plan-select",
  BILLING_PORTAL_ACCESS: "billing-portal-access",
  BILLING_PORTAL_ERROR: "billing-portal-error",
  BILLING_UPGRADE_ERROR: "billing-upgrade-error",
  NEED_LIMIT_CONTACT_ADMIN_ATTEMPT: "need-limit-contact-admin-attempt",
  NEED_LIMIT_CONTACT_ADMIN_ERROR: "need-limit-contact-admin-error",
  NEED_LIMIT_CONTACT_ADMIN_SUCCESS: "need-limit-contact-admin-success",
  NEED_LIMIT_UPGRADE_ATTEMPT: "need-limit-upgrade-attempt",
  NEED_LIMIT_UPGRADE_ERROR: "need-limit-upgrade-error",
  NEED_LIMIT_UPGRADE_SUCCESS: "need-limit-upgrade-success",
  NEED_USAGE_WARNING_UPGRADE_BUTTON_CLICK:
    "need-usage-warning-upgrade-button-click",
} as const;

export const AdminBillingEventCatalog: EventCatalogFromKeys<
  typeof AdminBillingEventKeys
> = {
  [AdminBillingEventKeys.BILLING_UPGRADE_ERROR]: {
    description: "An error occurred during billing upgrade",
    eventType: EventType.ERROR,
    id: AdminBillingEventKeys.BILLING_UPGRADE_ERROR,
  },
  [AdminBillingEventKeys.BILLING_ENTERPRISE_CONTACT]: {
    description: "User clicked to contact sales for enterprise plan",
    eventType: EventType.BUTTON_CLICK,
    id: AdminBillingEventKeys.BILLING_ENTERPRISE_CONTACT,
  },
  [AdminBillingEventKeys.BILLING_INTERVAL_CHANGE]: {
    description: "User changed the billing interval (monthly/yearly)",
    eventType: EventType.INTERACTION,
    id: AdminBillingEventKeys.BILLING_INTERVAL_CHANGE,
  },
  [AdminBillingEventKeys.BILLING_PLAN_SELECT]: {
    description: "User selected a billing plan",
    eventType: EventType.INTERACTION,
    id: AdminBillingEventKeys.BILLING_PLAN_SELECT,
  },
  [AdminBillingEventKeys.BILLING_PORTAL_ACCESS]: {
    description: "User accessed the billing portal",
    eventType: EventType.PAGE_VIEW,
    id: AdminBillingEventKeys.BILLING_PORTAL_ACCESS,
  },
  [AdminBillingEventKeys.BILLING_PORTAL_ERROR]: {
    description: "An error occurred during billing portal access",
    eventType: EventType.ERROR,
    id: AdminBillingEventKeys.BILLING_PORTAL_ERROR,
  },
  [AdminBillingEventKeys.NEED_LIMIT_CONTACT_ADMIN_ATTEMPT]: {
    description: "User attempted to contact admin for need limit upgrade",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminBillingEventKeys.NEED_LIMIT_CONTACT_ADMIN_ATTEMPT,
  },
  [AdminBillingEventKeys.NEED_LIMIT_CONTACT_ADMIN_ERROR]: {
    description:
      "An error occurred while contacting admin for need limit upgrade",
    eventType: EventType.ERROR,
    id: AdminBillingEventKeys.NEED_LIMIT_CONTACT_ADMIN_ERROR,
  },
  [AdminBillingEventKeys.NEED_LIMIT_CONTACT_ADMIN_SUCCESS]: {
    description: "User successfully contacted admin for need limit upgrade",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminBillingEventKeys.NEED_LIMIT_CONTACT_ADMIN_SUCCESS,
  },
  [AdminBillingEventKeys.NEED_LIMIT_UPGRADE_ATTEMPT]: {
    description: "User attempted to upgrade need limit",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminBillingEventKeys.NEED_LIMIT_UPGRADE_ATTEMPT,
  },
  [AdminBillingEventKeys.NEED_LIMIT_UPGRADE_ERROR]: {
    description: "An error occurred during need limit upgrade",
    eventType: EventType.ERROR,
    id: AdminBillingEventKeys.NEED_LIMIT_UPGRADE_ERROR,
  },
  [AdminBillingEventKeys.NEED_LIMIT_UPGRADE_SUCCESS]: {
    description: "User successfully upgraded need limit",
    eventType: EventType.FORM_SUBMISSION,
    id: AdminBillingEventKeys.NEED_LIMIT_UPGRADE_SUCCESS,
  },
  [AdminBillingEventKeys.NEED_USAGE_WARNING_UPGRADE_BUTTON_CLICK]: {
    description: "User clicked the upgrade button in need usage warning",
    eventType: EventType.BUTTON_CLICK,
    id: AdminBillingEventKeys.NEED_USAGE_WARNING_UPGRADE_BUTTON_CLICK,
  },
};
